var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8899 0.5C5.09239 0.5 0.389893 5.2025 0.389893 11C0.389893 16.7975 5.09239 21.5 10.8899 21.5C16.6874 21.5 21.3899 16.7975 21.3899 11C21.3899 5.2025 16.6874 0.5 10.8899 0.5ZM10.8899 20C5.92489 20 1.88989 15.965 1.88989 11C1.88989 6.035 5.92489 2 10.8899 2C15.8549 2 19.8899 6.0425 19.8899 11C19.8899 15.9575 15.8549 20 10.8899 20ZM10.9124 8.4425C11.1838 8.4425 11.4492 8.362 11.6749 8.21119C11.9006 8.06038 12.0765 7.84602 12.1804 7.59523C12.2843 7.34444 12.3115 7.06848 12.2585 6.80224C12.2056 6.536 12.0748 6.29144 11.8829 6.0995C11.6909 5.90755 11.4464 5.77683 11.1802 5.72387C10.9139 5.67091 10.638 5.69809 10.3872 5.80198C10.1364 5.90586 9.92201 6.08177 9.7712 6.30748C9.62039 6.53319 9.53989 6.79855 9.53989 7.07C9.53989 7.43401 9.68449 7.78311 9.94189 8.0405C10.1993 8.2979 10.5484 8.4425 10.9124 8.4425ZM11.7374 15.0875C10.8824 15.0875 10.8899 14.495 11.1149 13.625L11.7899 11L12.1799 9.5H7.89739V11H9.45739L8.70739 13.91C8.42239 14.915 8.63989 16.355 10.6799 16.355C11.9924 16.355 12.6749 15.6275 13.0349 14.915C12.8474 14.7725 12.8924 14.8025 12.7049 14.6675C12.4574 14.9 12.1349 15.0875 11.7374 15.0875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.1dbb6eb29c27d58cdf40d148efb3ef47.svg";
export { ForwardRef as ReactComponent };